import React, { useState, useEffect } from "react";
import { Avatar, Menu, MenuItem, IconButton, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { auth } from "../../firebase-config";

const ProfileSummary = ({ showDetails }) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [photoURL, setPhotoURL] = useState(null);
  const [displayName, setDisplayName] = useState("");
  const defaultProfilePic = "https://via.placeholder.com/150";

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setPhotoURL(user.photoURL || defaultProfilePic);
        setDisplayName(user.displayName || user.email);
      }
    });
    return () => unsubscribe();
  }, []);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/login");
  };

  return (
    <div className="profile-container">
      <IconButton onClick={handleMenuOpen} sx={{ padding: 0 }}>
        <Avatar 
            src={photoURL} 
            sx={{ width: 40, height: 40 }} 
        />
      </IconButton>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
        <MenuItem onClick={() => navigate("/profile")}>View Profile</MenuItem>
        <MenuItem onClick={handleLogout}>Log Out</MenuItem>
      </Menu>

      {showDetails && (
        <Typography variant="body2" sx={{ marginLeft: "10px", fontWeight: "bold", whiteSpace: 'nowrap' }}>
          {displayName}
        </Typography>
      )}
    </div>
  );
};

export default ProfileSummary;